import { P, match } from 'ts-pattern';

import { useAppointmentSummarizationWatch } from '@eluve/frontend-appointment-hooks';
import { useTranslation } from '@eluve/i18n';

import { useTranscriptionMachineSelector } from '../machines/transcription/hooks/useTranscriptionMachine';

import { AppointmentTranscriptionIdleControls } from './AppointmentTranscriptionIdleControls';
import { AppointmentTranscriptionInSessionControls } from './AppointmentTranscriptionInSessionControls';

interface TranscriptionControlsProps {
  tenantId: string;
  appointmentId: string;
}

export const AppointmentTranscriptionPageControls: React.FC<
  TranscriptionControlsProps
> = ({ appointmentId, tenantId }) => {
  const { t } = useTranslation();
  const sessionState = useTranscriptionMachineSelector((state) => {
    if (state.matches('Idle')) {
      return 'Idle';
    }
    if (state.matches('InSession')) {
      if (state.context.sessionAppointmentId !== appointmentId) {
        return 'AnotherAppointmentInSession';
      }
      return 'InSession';
    }
  });

  const { startWatchingForSummary } = useAppointmentSummarizationWatch({
    appointmentId,
    tenantId,
  });

  return match(sessionState)
    .with('Idle', P.nullish, () => (
      <AppointmentTranscriptionIdleControls
        tenantId={tenantId}
        appointmentId={appointmentId}
        onGenerateNote={() => startWatchingForSummary()}
      />
    ))
    .with('InSession', () => (
      <AppointmentTranscriptionInSessionControls
        onEndSession={() => startWatchingForSummary()}
      />
    ))
    .with('AnotherAppointmentInSession', () => (
      <span>{t('appointmentPage.controls.anotherAppointmentInSession')}</span>
    ))
    .otherwise(() => null);
};
